module.exports = __webpack_public_path__ + "img/901315129.759616dd.png";